export default __webpack_public_path__ + "static/media/twitter.e283d369.svg";